import React from 'react'
import { Button, Popconfirm } from 'antd'
import { DeleteOutlined, MinusCircleOutlined } from '@ant-design/icons'
import { deleteData } from '../../../../resources'

export default function EmtBoxDeleteCell({ record, box, fecha, fetchBoxes = () => { } }) {
    const handleDelete = () => {
        deleteData(`emt-box/delete-protocolo-fecha/${box._id}/${record.key}?fecha=${encodeURIComponent(fecha)}`)
            .then(() => {
                fetchBoxes();
            })
            .catch((error) => {
                console.error('Error deleting cell:', error);
            });
    }

    return (
            <Popconfirm
                title={`¿Eliminar la sesión del ${fecha}?`}
                onConfirm={handleDelete}
                okText="Sí"
                cancelText="No"
            >
                <Button type='link' shape='round' danger size='small' className='btnIconCentered' style={{alignSelf: 'flex-end', justifySelf: 'flex-end'}}>
                    <MinusCircleOutlined style={{ color: 'red', fontSize: '14px' }} />
                </Button>
            </Popconfirm>
       
    )
}
